import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { handleApiError } from "../api/instanceApi";
import {
  getForumDisscusions,
  createDiscussion,
  getDiscussionPosts,
  addDiscussionPost,
  deleteDiscussionPost,
  getAllForum,
  viewForum,
} from "../api/moodleForumApi";

export const useHandleForum = (id?: any) => {
  const queryClient = useQueryClient();

  const { data: allForums, isLoading: isAllForumsLoading, refetch: refetchAllForums } =
    useQuery({
      queryKey: ["all-forums"],
      queryFn: () => getAllForum(),
      refetchOnWindowFocus: true,
      refetchOnMount: false,
      staleTime: 6000,
    });

  const { data: forumDisscusion, isLoading: isForumDisscusionLoading, refetch: refetchDiscussions } =
    useQuery({
      queryKey: ["forum-discussions", id],
      queryFn: () => getForumDisscusions(id),
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: 6000,
    });

  const createDiscussionMutation = useMutation({
    mutationFn: (formData: any) => createDiscussion(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["forum-discussions", id],
      });
    },
    onError: handleApiError,
  });

  const { data: discussionPosts, isLoading: isDiscussionPostsLoading } =
    useQuery({
      queryKey: ["discussion-post", id],
      queryFn: () => getDiscussionPosts(id),
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: 6000,
    });

  const createPostMutation = useMutation({
    mutationFn: (postData: any) => addDiscussionPost(postData),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["discussion-post", id],
      });
    },
    onError: handleApiError,
  });

  const deletePostMutation = useMutation({
    mutationFn: (postId: any) => deleteDiscussionPost(postId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["discussion-post", id],
      });
    },

    onError: handleApiError,
  });

  const _viewForumMutation = useMutation({
    mutationFn: (forumid: any) => viewForum(forumid),
    onError: handleApiError,
  })

  return {
    discussionPosts,
    createDiscussion: createDiscussionMutation.mutate,
    createPost: createPostMutation.mutate,
    deletePost: deletePostMutation.mutate,
    forumDisscusion,
    isForumDisscusionLoading,
    allForums,
    isAllForumsLoading,
    refetchDiscussions,
    refetchAllForums,
    viewForum: _viewForumMutation.mutate,
    viewForumAsync: _viewForumMutation.mutateAsync,
    isViewingForum: _viewForumMutation.isPending,
    viewForumData: _viewForumMutation.data,
    viewForumError: _viewForumMutation.error,
  };
};
